import { getLeadSourceValue } from '../../utils/common';
import { getAdditionalPropertiesList } from './paymentOrderHelpers';
import CONSTANTS from '../../constants/externalReferences';
import {
  STRIPE,
  STRIPE_LOAD_TYPES,
} from '../../constants/stripePayment.constant';
import { getStripePaymentList } from '../../utils/stripeUtility';

export const isStripePaymentListActivity = (paymentInstrumentsList) => {
  const [paymentInstrumentNode] = paymentInstrumentsList;
  if (!paymentInstrumentNode) {
    return true;
  }
  const isStripePaymentName =
    getStripePaymentList(paymentInstrumentNode).type === STRIPE;
  if (isStripePaymentName) {
    return true;
  }
  return false;
};

export const isHideCheckoutStripePayment = (
  paymentInstruments,
  stripePaymentList,
) => {
  // For Checkout flow
  if (!paymentInstruments?.length) {
    if (!stripePaymentList?.StripePayment) {
      // value is the handler for payment method container stripe hide [true - hide stripe, false- show stripe]
      // type is the handler for [PaymentMethodStripe] component edit stripe handler [LOAD_PAYMENT_METHOD_STRIPE - load the payment method stripe[PaymentMethodStripe] & show cancel & save button]
      // This will load the direct stripe Elements from the PaymentMethodContainer & Hide the Edit Stripe payment element  in [PaymentMethodStripe] Component.
      return { value: true };
    }
    // Hide the stripe payment elements -  [PaymentMethodContainer & PaymentMethodStripe] and show the existing checkout flow
    return { value: false, type: STRIPE_LOAD_TYPES.loadCheckoutStripe };
  }
  if (paymentInstruments.length) {
    const isStripeAccount = isStripePaymentListActivity(paymentInstruments);
    // This will load the Edit stripe Elements from the Checkout flow - [PaymentMethodStripe] Component & Hide the  stripe Elements from [PaymentMethodContainer] component
    if (!isStripeAccount && stripePaymentList?.StripePayment) {
      return { value: false, type: STRIPE_LOAD_TYPES.loadPaymentMethodStripe };
    }
    if (isStripeAccount && stripePaymentList?.StripePayment) {
      return { value: true, type: STRIPE_LOAD_TYPES.loadPaymentMethodStripe };
    }
    // Hide the stripe payment elements -  [PaymentMethodContainer & PaymentMethodStripe] and show the existing checkout flow
    return { value: true };
  }
};

export const stripeCompleteOrderPayloadActivity = ({
  stripeCompleteOrderPayload,
  shoppingCartList,
  redemptionCodesPayload,
  defaultPaymentResponse,
  country,
  subscriberLeadSourceCodes,
}) => {
  const { AdditionalProperties, ThreeDSDetail } = stripeCompleteOrderPayload;
  const { ShoppingCart } = shoppingCartList;
  const RedemptionCodes = redemptionCodesPayload?.length
    ? redemptionCodesPayload
    : undefined;
  const PaymentInstruments = defaultPaymentResponse.paymentInstrumentIds;
  const additionalProperties = (additionalProps, country) => {
    if (!additionalProps) {
      const leadSourceValue = getLeadSourceValue(
        subscriberLeadSourceCodes?.Codes,
      );
      const additionalPropertiesList = [
        { key: CONSTANTS.COUNTRY_CODE, value: country },
        {
          key: CONSTANTS.LEAD_SOURCE,
          value: leadSourceValue,
        },
      ];
      const getAdditionalProperties = getAdditionalPropertiesList(
        additionalPropertiesList,
      );
      return getAdditionalProperties;
    }
    return additionalProps;
  };

  const threeDSDetail = (threeDSDetailNode) => {
    if (!threeDSDetailNode) {
      return {
        ThreeDSRedirectUriReference: ASCENDON_ENV_CONFIG.stripe.returnUrl,
      };
    }
    return threeDSDetailNode;
  };
  return {
    AdditionalProperties: additionalProperties(AdditionalProperties, country),
    ThreeDSDetail: threeDSDetail(ThreeDSDetail),
    RedemptionCodes,
    PaymentInstruments,
    ShoppingCart,
  };
};
